// The inward modal already shows "Inward Order Quantity: n" under the quantity field. That
// number is what the operator types in almost every case, so it is pre-filled into the field
// itself and left editable.
//
// One SKU can appear on several rows of the same inward order (different batches), in which
// case the label lists all of them and there is no single right answer to pre-fill. Guessing
// there would mean silently inwarding the wrong count, so the field is left blank and the
// label keeps doing its job.

/**
 * The value to pre-fill into the quantity field, or "" when the order does not name a single
 * unambiguous quantity.
 */
export function resolveInwardQuantityPrefill(quantities: unknown[]): string {
  if (!Array.isArray(quantities)) {
    return "";
  }

  const distinct = new Set(
    quantities.filter(
      (quantity): quantity is number =>
        typeof quantity === "number" && Number.isInteger(quantity) && quantity > 0
    )
  );

  if (distinct.size !== 1) {
    return "";
  }

  return String(distinct.values().next().value);
}
